import {
  Card,
  CardContent,
  CardMedia,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import SectionHeader from "../components/SectionHeader";
import * as textBodyMessage from "../Services/textBody";

const useStyles = makeStyles({
  about: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  card: {
    "&.MuiCard-root": {
      backgroundColor: "transparent",
      color: "#F5F5F5",
    },
  },
  cardMedia: {
    "&.MuiCardMedia-root": {
      borderBottomRightRadius: "170px",
      borderTopLeftRadius: "170px",
      border: "double 3px transparent",
      borderImageSlice: "1",
      borderWidth: "2.5px",
      backgroundImage:
        "linear-gradient(#1a1a1a, #1a1a1a),radial-gradient(circle at top left, #51a2e9, #ff4d5a)",
      backgroundOrigin: "border-box",
      backgroundClip: "content-box, border-box",
    },
  },
  bodyText: {
    "&.MuiTypography-root": {
      color: "#AAAAAA",
      fontFamily: "Rajdhani, sans-serif",
      fontWeight: "500",
      fontSize: "2.5rem",
      lineHeight: "2.5rem",
      paddingTop: "3rem",
    },
  },
});

function About() {
  const classes = useStyles();
  return (
    <Container maxWidth="lg" sx={{ minHeight: "100vh" }} id="about-container">
      <SectionHeader
        sectionTitle={textBodyMessage.about.pageTitle.toUpperCase()}
      />
      <Grid container spacing={5} mb={5}>
        <Grid item xs={12} md={6} className={classes.about}>
          <Card elevation={0} className={classes.card}>
            <CardMedia
              className={classes.cardMedia}
              component="img"
              alt={textBodyMessage.about.alt}
              image={textBodyMessage.about.image}
              height="250"
            />
            {/* <CardContent>
              <Typography
                component="div"
                variant="body2"
                className={classes.bodyText}
              >
                {textBodyMessage.about.aboutText1}
                <br />
                <br />
                {textBodyMessage.about.aboutText2}
                <br />
                <br />
                {textBodyMessage.about.aboutText3}
              </Typography>
            </CardContent> */}
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card elevation={0} className={classes.card}>
            <CardContent>
              <Typography
                component="div"
                variant="body2"
                className={classes.bodyText}
              >
                {textBodyMessage.about.aboutText1}
                <br />
                <br />
                {textBodyMessage.about.aboutText2}
                <br />
                <br />
                {textBodyMessage.about.aboutText3}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}

export default About;
